'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/8/4.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoeasyFullPageHeader = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GoeasyFullPageHeader, _Component);

  function GoeasyFullPageHeader() {
    (0, _classCallCheck3.default)(this, GoeasyFullPageHeader);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasyFullPageHeader).call(this));
  }

  (0, _createClass3.default)(GoeasyFullPageHeader, [{
    key: 'render',
    value: function render() {
      var styles = require('./GoeasyFullPageHeader.scss');
      var _props = this.props;
      var content = _props.content;
      var headerActiveIndex = _props.headerActiveIndex;
      var filedStyle = _props.filedStyle;
      var labelStyle = _props.labelStyle;
      var fromPages = _props.fromPages;

      var currentIndex = 0;
      var finalContent = content.map(function (item, index) {
        var currentItem = (0, _extends3.default)({}, item);
        currentItem.className = 'back' + (index + 1);
        if (currentItem.type === 'nav') {
          currentItem.index = currentIndex;
          ++currentIndex;
        }
        return currentItem;
      });
      var currentFieldStyle = { display: headerActiveIndex === 0 ? 'none' : 'block' };
      if (filedStyle) {
        currentFieldStyle = (0, _extends3.default)({}, currentFieldStyle, filedStyle);
      }
      return _react2.default.createElement(
        'ul',
        { className: styles.component, style: currentFieldStyle },
        finalContent instanceof Array ? finalContent.map(function (item, index) {
          var result = '';
          if (item.type === 'nav') {
            result = _react2.default.createElement(
              'li',
              { key: index,
                className: headerActiveIndex === item.index || fromPages === 'shopOrDesigner' && index === 1 ? styles.liActive : styles[item.className],
                style: labelStyle },
              _react2.default.createElement(
                'a',
                { href: '#' + item.href },
                _react2.default.createElement('i', {
                  className: styles[item.icon] }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.text
                )
              )
            );
          } else if (item.type === 'pop') {
            result = _react2.default.createElement(
              'li',
              { key: index, className: styles.border + ' ' + styles[item.className], style: labelStyle },
              _react2.default.createElement(
                'a',
                {
                  onClick: item.onClick },
                _react2.default.createElement('i', {
                  className: styles[item.icon] }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.text
                )
              )
            );
          } else if (item.type === 'link') {
            result = _react2.default.createElement(
              'li',
              { key: index, className: styles.border + ' ' + styles[item.className], style: labelStyle },
              _react2.default.createElement(
                'a',
                {
                  href: item.url,
                  target: '_blank' },
                _react2.default.createElement('i', {
                  className: styles[item.icon] }),
                _react2.default.createElement(
                  'span',
                  null,
                  item.text
                )
              )
            );
          }
          return result;
        }) : ''
      );
    }
  }]);
  return GoeasyFullPageHeader;
}(_react.Component), _class.propTypes = {
  content: _react.PropTypes.array,
  headerActiveIndex: _react.PropTypes.number,
  filedStyle: _react.PropTypes.object,
  labelStyle: _react.PropTypes.object,
  fromPages: _react.PropTypes.string
}, _temp);
exports.default = GoeasyFullPageHeader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyFullPageHeader/GoeasyFullPageHeader.js
 ** module id = 1344
 ** module chunks = 0
 **/